import ExternalContentListContainer from '@src/components/externalcontent/list/ExternalContentListContainer';
import React from 'react';

const ExternalContentListPage = () => <ExternalContentListContainer />

export default ExternalContentListPage;